export default "__VITE_ASSET__CRfJTM1g__"